import Vue from "vue"
import VueI18n from "vue-i18n"
import fr from "@/lang/fr"
import en from "@/lang/en"

Vue.use(VueI18n)

export default new VueI18n({
  locale: "fr",
  fallbackLocale: "en",
  messages: { fr, en },
})
